module.exports = __webpack_public_path__ + "static/media/fatherstephen_image4.bdecc448.jpg";